export default __webpack_public_path__ + "static/desktop_sek2_KV13-40fd7dbd0ccc6a5df94aaf120bfd67a5.mp4";